import { useContext, useEffect, useState } from 'react';
import { Grid, LinearProgress } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { GridContext } from 'contexts/GridContext';
import { DocumentosContext } from 'contexts/DocumentosContext';
import { CustomPagination } from 'utils/functions';
import localeText from 'utils/localeText';

const RespostasModal = ({ params }) => {
  const [respostas, setRespostas] = useState([]);
  const { deleteGrid, deleteLoading } = useContext(GridContext);
  const { getLoading, getQuestionarioResposta } = useContext(DocumentosContext);

  const loadData = () => getQuestionarioResposta({ params, cb: setRespostas });

  const onDelete = (id) => {
    const params = { rotina: 'DocumentoItemQualidadeResp', id };

    deleteGrid({ params, cb: loadData });
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          rows={respostas || []}
          columns={[
            {
              field: 'actions',
              type: 'actions',
              headerName: 'Ações',
              width: 100,
              getActions: ({ id }) => {
                return [
                  <GridActionsCellItem
                    icon={<Delete />}
                    label="Excluir"
                    onClick={() => onDelete(id)}
                  />,
                ];
              },
            },
            {
              field: 'grupo',
              headerName: 'Grupo',
              sortable: false,
              editable: false,
              width: 150,
            },
            {
              field: 'questionario',
              headerName: 'Questão',
              sortable: false,
              editable: false,
              minWidth: 300,
              flex: 1,
            },
            {
              field: 'resposta',
              headerName: 'Resposta',
              sortable: false,
              editable: false,
              width: 300,
            },
            {
              field: 'quantidade',
              headerName: 'Quantidade',
              type: 'number',
              sortable: false,
              editable: false,
              width: 120,
            },
            {
              field: 'resultado',
              headerName: 'Resultado',
              type: 'number',
              sortable: false,
              editable: false,
              width: 120,
            },
            // {
            //   field: 'conforme',
            //   headerName: 'Conforme',
            //   sortable: false,
            //   editable: false,
            //   width: 200,
            // },
            {
              field: 'observacao',
              headerName: 'Observação',
              sortable: false,
              editable: false,
              width: 250,
            },
            {
              field: 'name',
              headerName: 'Autor',
              sortable: false,
              editable: false,
              width: 300,
            },
          ]}
          loading={getLoading || deleteLoading}
          pagination
          autoHeight
          pageSize={10}
          density="compact"
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          localeText={localeText}
          disableSelectionOnClick
          components={{
            LoadingOverlay: LinearProgress,
            Pagination: CustomPagination,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default RespostasModal;
